import React, {FC, Fragment, ReactElement, useMemo} from 'react';
import {Activity, StudentActivity} from "../../../types";
import {Col, Row} from "antd";
import {DurationHistogramCard} from "../components/DurationHistogramCard";
import {StudentPerformanceDataTableCard} from "../components/StudentPerformanceDataTableCard";
import {GUTTER} from "../../../constants";
import {renderAttemptsFeedback} from "../../../components/DashboardViews/ActivityFeedbackRows";
import {useQuerySearchParams} from "../../../config/queryClient";
import {QueryFilter} from "../../../components/DataTable/Filters/types";
import {HistogramChartCard} from "../../../components/HistogramChartCard";
import {useLabels} from "../../../hooks/Labels";

export interface ActivityViewProps {
    activity: Activity,
}

export const Exercise: FC<ActivityViewProps> = ({activity}): ReactElement => {
    const {t} = useLabels();
    const activityId = activity.id.toString();
    const {data: attempts, isLoading: attemptsLoading} = useQuerySearchParams<StudentActivity[]>(
        '/reports/student-activities/', [QueryFilter.COHORTS], {
            autoExcludeRestrictedFields: false,
            defaultFilters: {
                activity: activityId || '',
                fields: 'best_score,best_attempt_duration_minutes'
            }
        })

    const scoreHistogramData = useMemo(() => attempts?.map(attempt => attempt.best_score).filter(score => score !== null), [attempts]);
    const durationHistogramData = useMemo(() => attempts?.map(attempt => attempt.best_attempt_duration_minutes).filter(duration => duration !== null), [attempts]);

    return (
        <Fragment>
            <Row gutter={GUTTER} style={{marginTop: GUTTER[0]}}>
                <Col xs={12} xxl={6}>
                    <HistogramChartCard
                        title='Score'
                        label={t('student_pl')}
                        data={scoreHistogramData as (number[] | undefined)}
                        unit='%'
                        isLoading={attemptsLoading}
                    />
                </Col>
                <Col xs={12} xxl={6}>
                    <DurationHistogramCard
                        isLoading={attemptsLoading}
                        data={durationHistogramData}
                        average={activity?.avg_completion_time_minutes}
                    />
                </Col>
                <Col xs={24} xxl={12}>
                    {renderAttemptsFeedback(activity, {flex: 1})}
                </Col>
            </Row>
            <Row gutter={GUTTER} style={{marginTop: GUTTER[0]}}>
                <StudentPerformanceDataTableCard activityId={activityId}/>
            </Row>
        </Fragment>
    );
};
